/**
 * Generated by orval v7.17.2 🍺
 * Do not edit manually.
 * WHIS API documentation
 * This document list all APIs available for WHIS project
 * OpenAPI spec version: 1.1.15
 */
import { useMutation, useQuery } from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';

import type {
  ImportReportResponseDto,
  ImportReportsBodyDto,
  ReportBodyDto,
  ReportResponseDto,
  ReportsCoordinatesDto,
  ReportsFindAllParams,
  ReportsFindCoordinatesParams,
  ReportsFindSimilarReportsParams,
  ReportsResponseDto,
  ReportsVersionDto,
  SimilarReportsResponseDto,
} from '.././model';

import { apiInstance } from '../../whisApi.instance';

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * @summary Get all reports with filter
 */
export const Reports_findAll = (
  params?: ReportsFindAllParams,
  options?: SecondParameter<typeof apiInstance>,
  signal?: AbortSignal,
) => {
  return apiInstance<ReportsResponseDto>(
    { url: `/api/reports`, method: 'GET', params, signal },
    options,
  );
};

export const getReportsFindAllQueryKey = (params?: ReportsFindAllParams) => {
  return ['api', 'reports', ...(params ? [params] : [])] as const;
};

export const getReportsFindAllQueryOptions = <
  TData = Awaited<ReturnType<typeof Reports_findAll>>,
  TError = unknown,
>(
  params?: ReportsFindAllParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof Reports_findAll>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof apiInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getReportsFindAllQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof Reports_findAll>>> = ({
    signal,
  }) => Reports_findAll(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof Reports_findAll>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ReportsFindAllQueryResult = NonNullable<
  Awaited<ReturnType<typeof Reports_findAll>>
>;
export type ReportsFindAllQueryError = unknown;

export function useReportsFindAll<
  TData = Awaited<ReturnType<typeof Reports_findAll>>,
  TError = unknown,
>(
  params: undefined | ReportsFindAllParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof Reports_findAll>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof Reports_findAll>>,
          TError,
          Awaited<ReturnType<typeof Reports_findAll>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useReportsFindAll<
  TData = Awaited<ReturnType<typeof Reports_findAll>>,
  TError = unknown,
>(
  params?: ReportsFindAllParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof Reports_findAll>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof Reports_findAll>>,
          TError,
          Awaited<ReturnType<typeof Reports_findAll>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useReportsFindAll<
  TData = Awaited<ReturnType<typeof Reports_findAll>>,
  TError = unknown,
>(
  params?: ReportsFindAllParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof Reports_findAll>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get all reports with filter
 */

export function useReportsFindAll<
  TData = Awaited<ReturnType<typeof Reports_findAll>>,
  TError = unknown,
>(
  params?: ReportsFindAllParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof Reports_findAll>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getReportsFindAllQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Create a new report
 */
export const Reports_create = (
  reportBodyDto: ReportBodyDto,
  options?: SecondParameter<typeof apiInstance>,
  signal?: AbortSignal,
) => {
  return apiInstance<ReportResponseDto>(
    {
      url: `/api/reports`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: reportBodyDto,
      signal,
    },
    options,
  );
};

export const getReportsCreateMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof Reports_create>>,
    TError,
    { data: ReportBodyDto },
    TContext
  >;
  request?: SecondParameter<typeof apiInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof Reports_create>>,
  TError,
  { data: ReportBodyDto },
  TContext
> => {
  const mutationKey = ['reportsCreate'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof Reports_create>>,
    { data: ReportBodyDto }
  > = (props) => {
    const { data } = props ?? {};

    return Reports_create(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ReportsCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof Reports_create>>
>;
export type ReportsCreateMutationBody = ReportBodyDto;
export type ReportsCreateMutationError = unknown;

/**
 * @summary Create a new report
 */
export const useReportsCreate = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof Reports_create>>,
      TError,
      { data: ReportBodyDto },
      TContext
    >;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof Reports_create>>,
  TError,
  { data: ReportBodyDto },
  TContext
> => {
  const mutationOptions = getReportsCreateMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Get coordinates of published reports
 */
export const Reports_findCoordinates = (
  params?: ReportsFindCoordinatesParams,
  options?: SecondParameter<typeof apiInstance>,
  signal?: AbortSignal,
) => {
  return apiInstance<ReportsCoordinatesDto>(
    { url: `/api/reports/coordinates`, method: 'GET', params, signal },
    options,
  );
};

export const getReportsFindCoordinatesQueryKey = (
  params?: ReportsFindCoordinatesParams,
) => {
  return [
    'api',
    'reports',
    'coordinates',
    ...(params ? [params] : []),
  ] as const;
};

export const getReportsFindCoordinatesQueryOptions = <
  TData = Awaited<ReturnType<typeof Reports_findCoordinates>>,
  TError = unknown,
>(
  params?: ReportsFindCoordinatesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof Reports_findCoordinates>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof apiInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getReportsFindCoordinatesQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof Reports_findCoordinates>>
  > = ({ signal }) => Reports_findCoordinates(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof Reports_findCoordinates>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ReportsFindCoordinatesQueryResult = NonNullable<
  Awaited<ReturnType<typeof Reports_findCoordinates>>
>;
export type ReportsFindCoordinatesQueryError = unknown;

export function useReportsFindCoordinates<
  TData = Awaited<ReturnType<typeof Reports_findCoordinates>>,
  TError = unknown,
>(
  params: undefined | ReportsFindCoordinatesParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof Reports_findCoordinates>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof Reports_findCoordinates>>,
          TError,
          Awaited<ReturnType<typeof Reports_findCoordinates>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useReportsFindCoordinates<
  TData = Awaited<ReturnType<typeof Reports_findCoordinates>>,
  TError = unknown,
>(
  params?: ReportsFindCoordinatesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof Reports_findCoordinates>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof Reports_findCoordinates>>,
          TError,
          Awaited<ReturnType<typeof Reports_findCoordinates>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useReportsFindCoordinates<
  TData = Awaited<ReturnType<typeof Reports_findCoordinates>>,
  TError = unknown,
>(
  params?: ReportsFindCoordinatesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof Reports_findCoordinates>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get coordinates of published reports
 */

export function useReportsFindCoordinates<
  TData = Awaited<ReturnType<typeof Reports_findCoordinates>>,
  TError = unknown,
>(
  params?: ReportsFindCoordinatesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof Reports_findCoordinates>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getReportsFindCoordinatesQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Get all similar report for filters provided
 */
export const Reports_findSimilarReports = (
  params: ReportsFindSimilarReportsParams,
  options?: SecondParameter<typeof apiInstance>,
  signal?: AbortSignal,
) => {
  return apiInstance<SimilarReportsResponseDto>(
    { url: `/api/reports/similar`, method: 'GET', params, signal },
    options,
  );
};

export const getReportsFindSimilarReportsQueryKey = (
  params?: ReportsFindSimilarReportsParams,
) => {
  return ['api', 'reports', 'similar', ...(params ? [params] : [])] as const;
};

export const getReportsFindSimilarReportsQueryOptions = <
  TData = Awaited<ReturnType<typeof Reports_findSimilarReports>>,
  TError = unknown,
>(
  params: ReportsFindSimilarReportsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof Reports_findSimilarReports>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof apiInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getReportsFindSimilarReportsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof Reports_findSimilarReports>>
  > = ({ signal }) =>
    Reports_findSimilarReports(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof Reports_findSimilarReports>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ReportsFindSimilarReportsQueryResult = NonNullable<
  Awaited<ReturnType<typeof Reports_findSimilarReports>>
>;
export type ReportsFindSimilarReportsQueryError = unknown;

export function useReportsFindSimilarReports<
  TData = Awaited<ReturnType<typeof Reports_findSimilarReports>>,
  TError = unknown,
>(
  params: ReportsFindSimilarReportsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof Reports_findSimilarReports>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof Reports_findSimilarReports>>,
          TError,
          Awaited<ReturnType<typeof Reports_findSimilarReports>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useReportsFindSimilarReports<
  TData = Awaited<ReturnType<typeof Reports_findSimilarReports>>,
  TError = unknown,
>(
  params: ReportsFindSimilarReportsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof Reports_findSimilarReports>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof Reports_findSimilarReports>>,
          TError,
          Awaited<ReturnType<typeof Reports_findSimilarReports>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useReportsFindSimilarReports<
  TData = Awaited<ReturnType<typeof Reports_findSimilarReports>>,
  TError = unknown,
>(
  params: ReportsFindSimilarReportsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof Reports_findSimilarReports>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get all similar report for filters provided
 */

export function useReportsFindSimilarReports<
  TData = Awaited<ReturnType<typeof Reports_findSimilarReports>>,
  TError = unknown,
>(
  params: ReportsFindSimilarReportsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof Reports_findSimilarReports>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getReportsFindSimilarReportsQueryOptions(
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Get a specific report by ID
 */
export const Reports_findOne = (
  reportId: string,
  options?: SecondParameter<typeof apiInstance>,
  signal?: AbortSignal,
) => {
  return apiInstance<ReportResponseDto>(
    { url: `/api/reports/${reportId}`, method: 'GET', signal },
    options,
  );
};

export const getReportsFindOneQueryKey = (reportId?: string) => {
  return ['api', 'reports', reportId] as const;
};

export const getReportsFindOneQueryOptions = <
  TData = Awaited<ReturnType<typeof Reports_findOne>>,
  TError = void,
>(
  reportId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof Reports_findOne>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof apiInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getReportsFindOneQueryKey(reportId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof Reports_findOne>>> = ({
    signal,
  }) => Reports_findOne(reportId, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!reportId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof Reports_findOne>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ReportsFindOneQueryResult = NonNullable<
  Awaited<ReturnType<typeof Reports_findOne>>
>;
export type ReportsFindOneQueryError = void;

export function useReportsFindOne<
  TData = Awaited<ReturnType<typeof Reports_findOne>>,
  TError = void,
>(
  reportId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof Reports_findOne>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof Reports_findOne>>,
          TError,
          Awaited<ReturnType<typeof Reports_findOne>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useReportsFindOne<
  TData = Awaited<ReturnType<typeof Reports_findOne>>,
  TError = void,
>(
  reportId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof Reports_findOne>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof Reports_findOne>>,
          TError,
          Awaited<ReturnType<typeof Reports_findOne>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useReportsFindOne<
  TData = Awaited<ReturnType<typeof Reports_findOne>>,
  TError = void,
>(
  reportId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof Reports_findOne>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get a specific report by ID
 */

export function useReportsFindOne<
  TData = Awaited<ReturnType<typeof Reports_findOne>>,
  TError = void,
>(
  reportId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof Reports_findOne>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getReportsFindOneQueryOptions(reportId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Delete a report (soft delete, just remove the last version)
 */
export const Reports_remove = (
  reportId: string,
  options?: SecondParameter<typeof apiInstance>,
) => {
  return apiInstance<void>(
    { url: `/api/reports/${reportId}`, method: 'DELETE' },
    options,
  );
};

export const getReportsRemoveMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof Reports_remove>>,
    TError,
    { reportId: string },
    TContext
  >;
  request?: SecondParameter<typeof apiInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof Reports_remove>>,
  TError,
  { reportId: string },
  TContext
> => {
  const mutationKey = ['reportsRemove'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof Reports_remove>>,
    { reportId: string }
  > = (props) => {
    const { reportId } = props ?? {};

    return Reports_remove(reportId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ReportsRemoveMutationResult = NonNullable<
  Awaited<ReturnType<typeof Reports_remove>>
>;

export type ReportsRemoveMutationError = void;

/**
 * @summary Delete a report (soft delete, just remove the last version)
 */
export const useReportsRemove = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof Reports_remove>>,
      TError,
      { reportId: string },
      TContext
    >;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof Reports_remove>>,
  TError,
  { reportId: string },
  TContext
> => {
  const mutationOptions = getReportsRemoveMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Get all versions of a specific report
 */
export const Reports_findVersions = (
  reportId: string,
  options?: SecondParameter<typeof apiInstance>,
  signal?: AbortSignal,
) => {
  return apiInstance<ReportsVersionDto>(
    { url: `/api/reports/${reportId}/versions`, method: 'GET', signal },
    options,
  );
};

export const getReportsFindVersionsQueryKey = (reportId?: string) => {
  return ['api', 'reports', reportId, 'versions'] as const;
};

export const getReportsFindVersionsQueryOptions = <
  TData = Awaited<ReturnType<typeof Reports_findVersions>>,
  TError = void,
>(
  reportId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof Reports_findVersions>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof apiInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getReportsFindVersionsQueryKey(reportId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof Reports_findVersions>>
  > = ({ signal }) => Reports_findVersions(reportId, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!reportId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof Reports_findVersions>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ReportsFindVersionsQueryResult = NonNullable<
  Awaited<ReturnType<typeof Reports_findVersions>>
>;
export type ReportsFindVersionsQueryError = void;

export function useReportsFindVersions<
  TData = Awaited<ReturnType<typeof Reports_findVersions>>,
  TError = void,
>(
  reportId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof Reports_findVersions>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof Reports_findVersions>>,
          TError,
          Awaited<ReturnType<typeof Reports_findVersions>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useReportsFindVersions<
  TData = Awaited<ReturnType<typeof Reports_findVersions>>,
  TError = void,
>(
  reportId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof Reports_findVersions>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof Reports_findVersions>>,
          TError,
          Awaited<ReturnType<typeof Reports_findVersions>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useReportsFindVersions<
  TData = Awaited<ReturnType<typeof Reports_findVersions>>,
  TError = void,
>(
  reportId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof Reports_findVersions>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get all versions of a specific report
 */

export function useReportsFindVersions<
  TData = Awaited<ReturnType<typeof Reports_findVersions>>,
  TError = void,
>(
  reportId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof Reports_findVersions>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getReportsFindVersionsQueryOptions(reportId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Request RRA for a report (admin and delegate only)
 */
export const Reports_requestRRA = (
  reportId: string,
  options?: SecondParameter<typeof apiInstance>,
) => {
  return apiInstance<ReportResponseDto>(
    { url: `/api/reports/${reportId}/requestRRA`, method: 'PATCH' },
    options,
  );
};

export const getReportsRequestRRAMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof Reports_requestRRA>>,
    TError,
    { reportId: string },
    TContext
  >;
  request?: SecondParameter<typeof apiInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof Reports_requestRRA>>,
  TError,
  { reportId: string },
  TContext
> => {
  const mutationKey = ['reportsRequestRRA'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof Reports_requestRRA>>,
    { reportId: string }
  > = (props) => {
    const { reportId } = props ?? {};

    return Reports_requestRRA(reportId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ReportsRequestRRAMutationResult = NonNullable<
  Awaited<ReturnType<typeof Reports_requestRRA>>
>;

export type ReportsRequestRRAMutationError = void;

/**
 * @summary Request RRA for a report (admin and delegate only)
 */
export const useReportsRequestRRA = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof Reports_requestRRA>>,
      TError,
      { reportId: string },
      TContext
    >;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof Reports_requestRRA>>,
  TError,
  { reportId: string },
  TContext
> => {
  const mutationOptions = getReportsRequestRRAMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Create a new report
 */
export const Reports_import = (
  importReportsBodyDto: ImportReportsBodyDto,
  options?: SecondParameter<typeof apiInstance>,
  signal?: AbortSignal,
) => {
  return apiInstance<ImportReportResponseDto>(
    {
      url: `/api/reports/import`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: importReportsBodyDto,
      signal,
    },
    options,
  );
};

export const getReportsImportMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof Reports_import>>,
    TError,
    { data: ImportReportsBodyDto },
    TContext
  >;
  request?: SecondParameter<typeof apiInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof Reports_import>>,
  TError,
  { data: ImportReportsBodyDto },
  TContext
> => {
  const mutationKey = ['reportsImport'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof Reports_import>>,
    { data: ImportReportsBodyDto }
  > = (props) => {
    const { data } = props ?? {};

    return Reports_import(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ReportsImportMutationResult = NonNullable<
  Awaited<ReturnType<typeof Reports_import>>
>;
export type ReportsImportMutationBody = ImportReportsBodyDto;
export type ReportsImportMutationError = unknown;

/**
 * @summary Create a new report
 */
export const useReportsImport = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof Reports_import>>,
      TError,
      { data: ImportReportsBodyDto },
      TContext
    >;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof Reports_import>>,
  TError,
  { data: ImportReportsBodyDto },
  TContext
> => {
  const mutationOptions = getReportsImportMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
